export const locations = [
  'north_america',
  'europe',
  'south_america',
  'middle_east',
  'asia',
  'africa',
  'oceania',
] as const
